<template><div class="sticky">
  <div class="main-ui" :class="{dark:typeof(dark)!=='undefined'}">
    <div v-if="!!$slots['more'] && showMore" class="more-cover" @click="showMore=false"></div>
    <a class="menu-icon icon" v-if="!$listeners.back" @click="$store.commit('showMenu')"><span>&#9776;</span></a>
    <a class="back-icon icon" v-else @click.prevent="$emit('back')"><span class="material-icons">arrow_back</span></a>
    <span class="title">
      <span class="slot"><slot>Sticky bar</slot></span>
      <div class="fade" />
      <transition name="loading" appear><loading v-if="loading" /></transition>
    </span>
    <a class="icon" v-if="typeof(search)!=='undefined'" @click.prevent="forceSearch=true">
      <span class="material-icons">search</span>
    </a>
    <a class="icon" v-else-if="$listeners.search" @click.prevent="$emit('search')">
      <span class="material-icons">search_off</span>
    </a>
    <transition name="icon">
      <a class="icon" v-if="$listeners.delete" @click.prevent="$emit('delete')">
        <span class="material-icons">delete</span>
      </a>
    </transition>
    <transition name="icon">
      <a class="icon" v-if="$listeners.add" @click.prevent="$emit('add')">
        <span class="material-icons">add</span>
      </a>
    </transition>
    <transition name="icon">
      <a class="icon" v-if="!!$slots['more']" @click.prevent="showMore=true">
        <transition name="more">
          <div ref="more" class="more" v-if="showMore" @click.stop="showMore=false">
            <slot name="more" />
          </div>
        </transition>
        <span class="material-icons">more_vert</span>
      </a>
    </transition>
    <transition name="icon">
      <a class="icon" v-if="$listeners.filter" @click.prevent="showFilter=!showFilter" :class="{veryDark:showFilter}">
        <span class="material-icons">
          {{ showFilter
            ? 'close'
            : (filterIcon || 'filter_list')
          }}
        </span>
      </a>
    </transition>
    <transition :name="searchTransition">
      <div class="search" v-if="searching" :class="searchClass">
        <sticky-bar @back="backClicked" dark @search="searchClicked">
          <input
            ref="search"
            type="text"
            :value="value"
            @input="$emit('input',$event.target.value)"
            :placeholder="search"
            @keydown.esc="forceSearch=false"
            @keydown.enter="$emit('accept')"
            @keydown.down="$emit('accept')"
            @blur="inputBlur" />
        </sticky-bar>
      </div>
    </transition>
  </div>
  <div class="filter" v-if="!!$slots['filter']">
    <slot name="filter" />
  </div>
</div></template>
<script>
import Loading from './Loading'
export default {
  name: 'sticky-bar',
  components: { Loading },
  props: ['search','dark','value','loading','filterIcon'],
  data() {
    return {
      forceSearch: false,
      showMore: false,
      showFilter: false,
    }
  },
  mounted() {
    if (this.searching) {
      this.forceSearch = true
      this.$refs.search.focus()
    }
  },
  computed: {
    iconStyle() { return { 'font-size': this.back ? '24px' : '24px' } },
    iconName() { return this.back ? 'arrow_back_ios' : 'menu' },
    searching() { return !!this.value || this.forceSearch },
    searchShift() {
      let i = 0
      if (!!this.$slots['more']) i++
      if (!!this.$listeners['filter']) i++
      return i
    },
    searchClass() { return 'shift' + this.searchShift },
    searchTransition() { return 'bubble1' },
  },
  methods: {
    backClicked() {
      this.forceSearch = false
      this.$emit('input', '')
    },
    searchClicked() {
      this.forceSearch = true
      this.$emit('input', '')
      this.$nextTick(() => {
        this.$refs.search.focus()
      })
    },
    focusSearch() {
      if (!this.$refs.search)
        return false
      this.$refs.search.focus()
      return true
    },
    inputBlur() {
      this.forceSearch = !!this.value
    },
  },
  watch: {
    forceSearch(nv) {
      if (nv) {
        this.$emit('input', this.value)
        this.$nextTick(() => {
          this.$refs.search.focus()
        })
      } else {
        this.$emit('input', null)
      }
    },
    showFilter(nv) {
      this.$emit('filter', nv)
    },
  },
}
</script>
<style lang="scss">

.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 50;

  > .main-ui {
    background: #ddd;
    font-size: 20px;
    min-height: 50px;
    display: flex;
    align-items: center;
    cursor: default;
    position: relative;

    &.dark {
      background: #ccc;
      .fade { display: none; }
    }


    .icon {
      display: inline-block;
      width: 50px;
      margin: 0 0px;
      text-align: center;
      align-self: stretch;
      cursor: default;
      position: relative;

      > span {
        display: inline-block;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
      }

      &.veryDark {
        background: #aaa;
      }
    }

    .menu-icon { margin: 0 -20px 0 0; font-size: 0; }

    .fade {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 50px;
      background-image: linear-gradient(to right, rgba(221,221,221,0), rgba(221,221,221,1));
    }

    .title {
      flex-grow: 1;
      white-space: nowrap;
      overflow-x: hidden;
      position: relative;
      align-self: stretch;
      overflow: hidden;

      > .loading, .slot {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }

      .slot {
        left: 0px;
        right: 0px;
        small { display: block; font-size: 60%; }
      }

      .loading {
        margin: 0 20px;
        right: 10px;

        transition: all 2s 1s;
        background-color: rgba(255,255,255,.9);
        box-shadow: 0 0 15px 15px rgba(255,255,255,.9);
        border-radius: 100px;
      }
    }

    .search {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;

      $t1: .1s;   // fade enter time
      $t2: .3s;   // bubble clip enter time
      $t3: .25s;  // bubble clip leave time

      &.bubble1-enter    { opacity: 0; clip-path: circle(0vw at calc(100% - 25px) 50%); }
      &.bubble1-enter-to { opacity: 1; clip-path: circle(100vw at calc(100% - 25px) 50%); transition: opacity $t1, clip-path $t2; }
      &.bubble1-leave    { clip-path: circle(100vw at calc(100% - 25px) 50%); }
      &.bubble1-leave-to { clip-path: circle(0vw at calc(100% - 25px) 50%); transition: clip-path $t3; }

      &.bubble2-enter    { opacity: 0; clip-path: circle(0vw at calc(100% - 75px) 50%); }
      &.bubble2-enter-to { opacity: 1; clip-path: circle(100vw at calc(100% - 75px) 50%); transition: opacity $t1, clip-path $t2; }
      &.bubble2-leave    { clip-path: circle(100vw at calc(100% - 75px) 50%); }
      &.bubble2-leave-to { clip-path: circle(0vw at calc(100% - 75px) 50%); transition: clip-path $t3; }

      &.bubble3-enter    { opacity: 0; clip-path: circle(0vw at calc(100% - 125px) 50%); }
      &.bubble3-enter-to { opacity: 1; clip-path: circle(100vw at calc(100% - 125px) 50%); transition: opacity $t1, clip-path $t2; }
      &.bubble3-leave    { clip-path: circle(100vw at calc(100% - 125px) 50%); }
      &.bubble3-leave-to { clip-path: circle(0vw at calc(100% - 125px) 50%); transition: clip-path $t3; }

      input {
        width: 100%;
        border: 0;
        outline: 0;
        background: inherit;
      }
    }

    .loading {
      width: 20px;
      height: 20px;
    }

    .more {
      position: absolute;
      top: 10px;
      right: 10px;
      max-width: 300px;
      box-sizing: border-box;
      border-radius: 5px;
      background: #fff;
      padding: 20px;
      z-index: 101;



      .more-menu {
        text-align: left;
        a {
          padding: 5px 10px;
          font-size: 18px;
          margin: 0 2.5px;
          text-align: center;
          text-decoration: none;
          cursor: pointer;
          display: block;
          &:hover {
            font-weight: bold;
          }
          &.selected {
            background-color: #fff;
          }
        }
      }



      > a {
        white-space: nowrap;
        text-decoration: none;
      }
      transform-origin: top right;

    }

    .more-cover {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 100;
    }

    .more-enter { transform: scale(0); }
    .more-enter-to { transition: all .25s; }
    .more-leave { }
    .more-leave-to { opacity: 0; transition: all .25s; }

    .loading-enter { opacity: 0; }
    .loading-enter-to { }
    .loading-leave { }
    .loading-leave-to { opacity: 0; transition: all .25s !important; }

    .icon-enter { width: 0px; }
    .icon-enter-to { transition: all .5s; }

    .shift0 { }
    .shift1 { margin-right: 50px; }
    .shift2 { margin-right: 100px; }
  }

  > .filter {
    background-color: #aaa;
  }
}

</style>
